<template>
<div>
  <vHeader>
    <div class="login box">
      <router-link class="pure-button pure-button-primary sign-up-button" :to="{ name: 'sign_up' }">会社登録</router-link>
      <router-link class="pure-button login-button" :to="{ name: 'login' }">ログイン</router-link>
    </div>
  </vHeader>

  <div class="main-content">
    <div class="content">
      <div class="nest-content">
        <img class="index-screen" src="@/assets/web_header.jpg">
      </div>
    </div>
  </div>
</div>
</template>

<script>
import vHeader from "@/components/header.vue"

export default {
  components: {
    vHeader
  }  
}
</script>

<style lang="scss" scoped>
.login {
  position: absolute;
  right: 8px;
  top: 8px;

  .sign-up-button {
    background: linear-gradient(-45deg, #fff5ee, #83ccd2);
    color: black;
  }

  .login-button {
    background: linear-gradient(135deg, #fff5ee, #83ccd2);
  }

  a {
    margin-left: 8px;
    margin-right: 10px;
    margin-top: 16px;
  }
}

.nest-content {
  height: calc(100% - 106px);
}

.index-screen {
  height: 100%;
}

@media screen and (max-width: 420px) {
  .login {
    right: 4px;
    top: 4px;

    a {
      margin: 0px;
    }
  }

  .nest-content {
    height: calc(100% - 66px);
  }

  .index-screen {
    width: 100%;
    height: auto;
  }
}
</style>